//components
import React from "react";
import { connect } from "react-redux";
import Carousel from "react-multi-carousel";
import Button from "@material-ui/core/Button";
import { OperationStatus } from "../../Communication/Constants";
import { PATHS } from "./../../Constants";
import { withRouter } from "react-router-dom";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import CryptoJS from "crypto-js";
import OtpVerificationAction from "../OtpVerification/OtpVerificationAction";
import NewUserCard from "./NewUserCard/NewUserCard"

//carousel css
import "react-multi-carousel/lib/styles.css";

//components
import UserCard from "./UserCard/UserCard";
import CustomSpinner from "../Spinner/Spinner";
import DashBordAction from "../Dashboard/DashboardAction";
import { Modal } from "../CustomModal/Modal";
import { InvitationModal } from "../InvitationModal/InvitationModal";
import { Strings } from "../../Resources/Strings/i18n";

//resources
import NodataImg from "../../Resources/Images/ic_no_data.png";
import LeftArrow from "../../Resources/Images/ic_arrow_left_blue.png";
import RightArrow from "../../Resources/Images/ic_arrow_right_blue.png";

//styling
import "./Dashboard.scss";
import CommonUtils from "../../Utils/CommonUtils";
import SelfDataCard from "./SelfDataCard/SelfDataCard";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceType: "",
      showModal: false,
      showErrorModal: false,
      errorMessage: "",
      test: true,
      hintAns: false,
      calInfo: false,
      showMyData: false,
      userConfigData: {},
    };
    this.DashBordAction = new DashBordAction();
    this.verifyOTP = new OtpVerificationAction();
  }
 
  componentDidUpdate(prevprops) {
    if (!prevprops.userInfo || !prevprops.userInfo.accessToken) {
      this.props.history.push(PATHS.LOGIN);
    }
}
  componentDidMount() {
    localStorage.removeItem("selectedAlertId");
    localStorage.removeItem("myState");
    localStorage.removeItem("myDataState");
    this.props.cleanSummaryData();

    if (!this.props.userInfo || !this.props.userInfo.accessToken) {
      this.props.history.push(PATHS.LOGIN);
    }
    //This if is added to avoid logged out users to navigate to home diretly using URL
    if (this.props.userInfo && this.props.userInfo.id) {
      this.setState({ showModal: true });
      if (
        this.props.inviteTokenInfo &&
        this.props.inviteTokenInfo.isInvitedUser
      ) {
        this.DashBordAction.getInvitationInfo((actionCallback) => {
          if (actionCallback.status === OperationStatus.SUCCESS) {
            this.getSummary();
          } else {
            this.setState({
              spinner: false,
              errorCase: true,
              errorMessage: actionCallback.error.errorMessage,
              showModal: false,
            });
          }
        });
      }

      this.DashBordAction.getList(
        {
          userid: this.props.userInfo.id, //this.props.currentUserInfo.accessToken,
        },
        (listResponse) => {
          if (
            !(
              this.props.inviteTokenInfo &&
              this.props.inviteTokenInfo.isInvitedUser
            )
          ) {
            this.getSummary();
          }
          this.setState({
            showErrorModal: false,
            errorMessage: listResponse.error.errorMessage,
            showModal: false,
          });
        }
      );
      this.getMySummaryData()
      this.getUserConfig()
      this.setState({ showModal: true });
    } else {
      this.setState({
        showErrorModal: true,
        errorMessage: Strings("ERROR_INVALID_AUTH_GRANT"),
        //"Session expired or error occurred, please login again!",
      });
    }
  }

  decryptTextCrypto = (ciphertext) => {
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_CRYPTO_KEY);
    var decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    let res = decryptedData.split("&");
    let keyValueArr = res.map((item) => item.split("="));
    return keyValueArr;
  };

  //login invited user
  loginInvitedUser = () => {
    this.setState({showModal:true})
    let ciphertext = this.props.inviteTokenInfo && this.props.inviteTokenInfo.web_data
    let invitedUserData = this.decryptTextCrypto(ciphertext);
    let email = ""
      let mobile = ""
    let calling_code = ""
    let otp=""
    invitedUserData.forEach((innerItem) => {
        email = innerItem[0] === "email" ? innerItem[1] : email
        mobile = innerItem[0] === "mobile" ? innerItem[1] : mobile
        calling_code = innerItem[0] === "callingCode" ? innerItem[1] : calling_code
        otp = innerItem[0] === "otp" ? innerItem[1] : otp
    })
    let requestObj={
          mobile: mobile,
          calling_code: calling_code,
          otp: otp,
          device_type: 3, //iOS/Android/Web
          //device_token: "1234567890",
          user_agent: "web", // Android/iOS/Web/Chrome
    }
    if (email !== "") {
      requestObj={
       email:email,
        otp: otp,
        device_type: 3, //iOS/Android/Web
        //device_token: "1234567890",
        user_agent: "web", // Android/iOS/Web/Chrome
  }
    }

this.verifyOTP.verifyOTP(
  requestObj,
  (actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
          let loggedInUserData = JSON.stringify(
              actionCallback.data,
              null,
              2
          );
          this.setState({
              userid: actionCallback.data.data.id,
              fetchedUserData: loggedInUserData,
              showDashboard: true,
              showModal: false,
              errorMessage: "",
          });
        this.props.cleanInvitedUserData()
          this.props.history.push(PATHS.HOME);
      }
        else {
          this.setState({
              errorCase: true,
              errorMessage: actionCallback.error.errorMessage,
              otpEntered: "",
              showModal: false,
          });
      }
  }
);
 
  };

  getSummary() {
    var reqObj = {
      addUserIdInRequest: false,
      loggedInUserId: this.props.userInfo.id,
      forDate: undefined,
      for_userid: this.props.userInfo.id,
      actionFlag: false,
    };
    if (
      this.props.inviteTokenInfo &&
      this.props.inviteTokenInfo.isInvitedUser
    ) {
      reqObj = {
        addUserIdInRequest: true,
        loggedInUserId: this.props.userInfo.id,
        forDate: undefined,
        for_userid: this.props.invitedUserInfo.inviter.user_id,
        actionFlag: false,
      };
    }
    this.DashBordAction.getSummeryData(reqObj, (summaryResponse) => {
      if (summaryResponse.status === OperationStatus.SUCCESS) {
        this.setState({
          summartData: summaryResponse.data.data,
          showModal: false,
        });
      } else {
        this.setState({
          showErrorModal: false,
          errorMessage: summaryResponse.error.errorMessage,
          showModal: false,
        });
      }
    });
  }

  getMySummaryData = () => {
    var reqObj = {
      addUserIdInRequest: true,
      loggedInUserId: this.props.userInfo.id,
      forDate: undefined,
      for_userid: this.props.userInfo.id,
    }
    this.DashBordAction.getSelfSummaryData(reqObj,(response)=>{
      if (response.status === OperationStatus.SUCCESS) {
        this.setState({
          mySummaryData: response.data.data,
          showModal: false,
        });
      } else {
        // console.log('Data Summary Not Found!', response.error);
        this.setState({
          showErrorModal: false,
          errorMessage: response.error.errorMessage,
          showModal: false,
        });
      }
    })

  }

  getUserConfig = () => {
    this.DashBordAction.getUserConfig("",(actionCallback) => {
      if (actionCallback.status === OperationStatus.SUCCESS) {
        this.setState({userConfigData: actionCallback.data.data});
      }

      else if (actionCallback.error) {
        this.setState({showError: true, showModal: true, errorMessage: actionCallback.error.errorMessage })
      }
    })
  }

  displayMyData = () => {
    this.setState({ showMyData: true });
  };

  displayLovedOneData = () => {
    this.setState({ showMyData: false });
  };

  renderSelfDataCard = (userSummary,index) => {
    return (
      <SelfDataCard
      userSummery={userSummary}
      first_name={this.props.userInfo.first_name}
      last_name={this.props.userInfo.last_name}
      history={this.props.history}
      key={index}
      configData={this.props.configData.data}
      >
      </SelfDataCard>
    )
  }

  renderCards = (item, userSummery, index) => {
    return (
      <NewUserCard
        setCalInfo={(status) => this.setState({ calInfo: status })}
        userSummery={userSummery}
        index={index}
        id={item.id}
        first_name={item.first_name}
        last_name={item.last_name}
        relation={item.relation}
        deviceType={this.state.deviceType}
        plan={item.subscription.product.display_name}
        chartsStatus={
          item.subscription.product.features.parameters.charts.status
        }
        history={this.props.history}
        history_data_display={
          item.subscription.product.features.history_data_display
        }
        history_days_available={
          item.subscription.product.features.history_days_available
        }
        history_data_display_unit={
          item.subscription.product.features.history_data_display_unit
        }
        data_update_interval_minutes={
          item.subscription.product.features.data_update_interval_minutes
        }
      ></NewUserCard>
    );
  };
  setDeviceType = (deviceType) => {
    this.setState({ deviceType });
  };

  render() {
    const responsive = {
      superLargeDesktop: {
        breakpoint: { max: 4000, min: 1440 },
        items: 2,
      },
      desktop: {
        breakpoint: { max: 1440, min: 1024 },
        items: 2,
      },
      tablet: {
        breakpoint: { max: 1024, min: 768 },
        items: 1,
      },
      mobile: {
        breakpoint: { max: 768, min: 0 },
        items: 1,
      },
    };
    const CustomButtonGroupAsArrows = ({
      next,
      previous,
      goToSlide,
      ...rest
    }) => {
      const {
        carouselState: { currentSlide },
      } = rest;
      /* if (rest.carouselState.deviceType !== this.state.deviceType) {
        this.setDeviceType(rest.carouselState.deviceType);
      } */
      const lastImageIndex = this.props.summeryUserList && this.props.summeryUserList.length - 1;
      // if (rest.carouselState.slidesToShow < (rest.carouselState.totalItems / rest.carouselState.slidesToShow))
      if (this.props.summeryUserList && this.props.summeryUserList.length > 1)
        return (
          <div style={{ textAlign: "center" }}>
            <img
              alt="prevScroll"
              className="cardContainer leftScroll"
              src={LeftArrow}
              onClick={() =>
                currentSlide === 0 ? goToSlide(lastImageIndex) : previous()
              }
            ></img>
            <img
              alt="nextScroll"
              className="cardContainer rightScroll"
              src={RightArrow}
              onClick={() =>
                currentSlide === lastImageIndex ? goToSlide(0) : next()
              }
            ></img>
          </div>
        );
      else {
        return <div></div>;
      }
    };
    return (
      <div>
        <div>
          {this.state.showErrorModal || this.state.hintAns ? (
            <Modal
              show={this.state.showErrorModal || this.state.hintAns}
              handleClose={this.hideModal}
              parent={"exitsession"}
            >
              {
                <div>
                  <div className="errorOtp">
                    <div className="errorModal">
                      <div className="modalTitle">
                        <p id="errorTitle">
                          {this.state.showErrorModal ? (
                            <>
                              <span id="errorText">{Strings("Error")}</span>
                              {Strings("ErrorOccurred")}
                            </>
                          ) : null}
                        </p>
                      </div>
                      <div className="errorContainer">
                        <div className="errorContent">
                          {this.state.showErrorModal ? (
                            <p>{this.state.errorMessage}</p>
                          ) : (
                            <p className="BloodPressureInfo">
                              {Strings("BloodPressureInfo") +
                                " " +
                                Strings("GoogleFit")}
                            </p>
                          )}
                        </div>
                      </div>
                      <Button
                        className={
                          this.state.hintAns
                            ? "errorBtn errorBtnBlue"
                            : "errorBtn"
                        }
                        onClick={() => {
                          this.setState(
                            {
                              showErrorModal: false,
                              hintAns: false,
                            },
                            () => {
                              !this.props.userInfo.id
                                ? this.props.history.push(PATHS.LOGIN)
                                : this.props.history.push();
                            }
                          );
                        }}
                      >
                        {this.state.showErrorModal
                          ? this.state.errorMessage ===
                            String("ERROR_INVALID_AUTH_GRANT")
                            ? Strings("CloseAndLogin")
                            : Strings("Close")
                          : Strings("Ok")}
                      </Button>
                    </div>
                  </div>
                </div>
              }
            </Modal>
          ) : null}
        </div>

        <div className="homeView">
          <CustomSpinner showModal={this.state.showModal} />
          <div className="ButtonContainer">
        <div
          className={
            this.state.showMyData ? "selfDataBtn selected" : "selfDataBtn"
          }
        >
          <Button onClick={this.displayMyData} variant="contained" color="primary">
            <div> {Strings("myData")}</div>
          </Button>
        </div>
        <div
          className={
            !this.state.showMyData
              ? "lovedOnesDataBtn selected"
              : "lovedOnesDataBtn"
          }
        >
          <Button
            onClick={this.displayLovedOneData}
            variant="contained"
            color="primary"
          >
            <div> {Strings("MyLovedOnes")}</div>
          </Button>
        </div>
      </div>
          { 
          !this.state.showMyData && this.props.summeryUserList && this.props.summeryUserList.length !== 0 ? (
            <div
              className={
                this.props.summeryUserList && this.props.summeryUserList.length === 1
                  ? "cardRowNew"
                  : "cardRow"
              }
            >
              <Carousel
                //infinite={true}
                draggable={false}
                swipeable={false}
                responsive={responsive}
                arrows={false}
                renderButtonGroupOutside={true}
                transitionDuration={500}
                containerClass="carousel-container"
                deviceType={this.props.deviceType}
                customButtonGroup={<CustomButtonGroupAsArrows />}
                className="cardList"
                itemClass="carousel-item-padding-20-px"
                beforeChange={(nextSlide, { currentSlide, onMove }) => {
                  //API calls();
                  //this.props.getSummeryData(item.id);
                  //alert(currentSlide);
                }}
              >
                {this.props.userList.monitored_users && this.props.userList.monitored_users.map((itemInfo, index) => {
                  return this.props.summeryUserList.map((userSummery) => {
                    if (userSummery.user_id === itemInfo.id) {
                      return this.renderCards(itemInfo, userSummery, index);
                    } else return null;
                  });
                })}
              </Carousel>
            </div>
          ) : 
          (
            <div>
            </div>
          ) 
          }
          {
            this.state.showMyData && this.props.selfSummaryData && this.props.selfSummaryData.length === 1 ? (
              <div className="cardRowNew">
              <Carousel
                responsive={responsive}
                containerClass="carousel-container"
                deviceType={this.props.deviceType}
                >
                {this.props.selfSummaryData.map((userSummary,index)=>{
                  return this.renderSelfDataCard(userSummary,index);
                })}
              </Carousel>
              </div>
            ):(
              <div></div>
            )
          }
          {/* Below block will get execute and display no data available when user does not have loved ones summary */}
          { !this.state.showMyData &&
            this.props.summeryUserList 
            && this.props.summeryUserList.length === 0 ? 
            (<div className="noData">
              <img
                className="noDataImg"
                src={NodataImg}
                alt="No data available"
              />
              <div className="noDataText">{Strings("NoDataAvailable")}</div>
            </div>) :
            (<div>
            </div>)
          }
          {/* Below block will get execute and display no data available when user does not self data */}
          {
            this.state.showMyData &&
            this.props.selfSummaryData 
            && this.props.selfSummaryData.length === 0 ? 
            (<div className="noData">
              <img
                className="noDataImg"
                src={NodataImg}
                alt="No data available"
              />
              <div className="noDataText">{Strings("NoDataAvailable")}</div>
            </div>) :
            (<div>
            </div>)
          }
        </div>
        {this.props.inviteTokenInfo &&
          this.props.inviteTokenInfo.isInvitedUser && (
            <InvitationModal
              userName={
                this.props.invitedUserInfo.inviter.first_name +
                (this.props.invitedUserInfo.inviter.last_name
                  ? " " + this.props.invitedUserInfo.inviter.last_name
                  : null)
              }
            installLink={this.props.inviteTokenInfo.installLink}
            loginInvitedUser={this.loginInvitedUser}
            ></InvitationModal>
          )}
        
       
        <Snackbar
          open={this.state.calInfo}
          autoHideDuration={1000}
          onClose={() => {}}
          className="hintAnswer"
        >
          <MuiAlert onClose={() => {}} severity="success">
            {Strings("caloriesInfoText")}
          </MuiAlert>
        </Snackbar>
      </div>
    );
  }
}

Dashboard.defaultProps = {
  userInfo: { Error: "No data recieved" },
  userList: { Error: "No data recieved" },
  summeryUserList: { Error: "No data recieved" },
  inviteTokenInfo: { Error: "No data received" },
  invitedUserInfo: { Error: "No data received" },
  selfSummaryData: { Error: "No data received" },
  configData: { Error: "No data received" },
};

function mapStateToProps(state) {
  return {
    userInfo: CommonUtils.getInvitedTokenInfo(state),
    userList: state.Dashboard.userInfo,
    summeryUserList: state.Dashboard.summeryUserList,
    invitedUserInfo: state.Dashboard.invitedUserInfo,
    inviteTokenInfo: state.InvitationHandler.accessInfo,
    selfSummaryData: state.Dashboard.selfSummaryData,
    configData: state.Dashboard.configData,
  };
}
const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    cleanInvitedUserData: () => dispatch({ type: 'CLEAN_INVITED_USER_DATA' }),
    cleanSummaryData:() => dispatch({ type: 'CLEAN_SUMMARY_DATA_ACTION'}),
   
  }
}
export default withRouter(
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(Dashboard)
);
